'use client';

import cancelIlustration from '@/components/icons/CancelIlustration.svg';

export const CancelIlustration = () => {
	return (
		<div className="flex w-full justify-center overflow-hidden">
			{/* add className to the image if you want to change the size */}
			<img src={cancelIlustration.src} alt="Cancel Ilustration" className="h-32 w-[350px] md:w-[550px] lg:w-[600px]" />
		</div>
	);
};
